module.exports = __webpack_public_path__ + "img/next.b5b55574.png";